export const handleWhatsAppClick = () => {
  window.open(`https://wa.me/971525218176`, '_blank');
};

export const handleEmailClick = () => {
  window.location.href = "mailto:support@pipgrid.com";
};
